import { t } from '@lingui/core/macro';
import { customerRoutes } from 'noddi-util';
import { PasswordResetConfirm, tracking } from 'noddi-web';
import { LoginCard } from '../../components/Login/LoginCard';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { getErrorCodesWithTrans } from '../../utils/getErrorCodesWithTranslations';

export const ResetPassword = () => {
  const { brandEmail } = useCurrentBrand();

  return (
    <PasswordResetConfirm
      loginPath={customerRoutes.emailLogin.getPath()}
      layout={LoginCard}
      errorCodes={getErrorCodesWithTrans(brandEmail)}
      loginSuccessPath={customerRoutes.userSelection.getPath()}
      trackUserIdentity={(user) => {
        tracking.trackUserLogin(user);
      }}
      translations={{
        resetYourPassword: t`Reset your password`,
        enterNewPassword: t`Enter your new password below`,
        newPassword: t`New password`,
        confirmPassword: t`Confirm password`,
        resetPassword: t`Reset password`,
        backToLogin: t`Back to login`,
        invalidResetLink: t`Invalid reset link`,
        invalidResetLinkMessage: t`This password reset link is invalid or has expired. Please request a new one.`,
        passwordResetSuccessful: t`Password changed`,
        passwordResetSuccessfulMessage: t`Sign in with your new password.`,
        passwordRequired: t`Password is required`,
        passwordMinLength: t`Password must be at least 12 characters`,
        confirmPasswordRequired: t`Please confirm your password`,
        passwordsDontMatch: t`Passwords don't match`,
        linkExpiresIn: t`The link expires in`,
        linkExpired: t`The link has expired. Request a new one to continue.`
      }}
    />
  );
};
